<div style="background-color: var(--tdo-background);" (appClickOutside)="onClickOutside()" data-cy="home-accordion-container">
  <mat-accordion class="home-accordion" data-cy="home-accordion">
    <!--SCHEDULE-->
    <mat-expansion-panel #schedDropdown (opened)="schedulePanelOpenState = true"
      (closed)="schedulePanelOpenState = false" data-cy="home-accordion-schedule-panel">
      <mat-expansion-panel-header [ngStyle]="{'height': isExpanded ? '36px' : '50px'}" data-cy="home-accordion-schedule-header">
        <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-schedule-title">
          <div class="accordion-header" data-cy="home-accordion-schedule-header-content">
            <div matTooltip="Scheduler" style="flex-basis: fit-content; margin-right: 15px; position: relative; top: 1px;" data-cy="home-accordion-schedule-icon-container">
              <img style="height: 50%; cursor: pointer;" (click)="openSchedulerInNewWindow()" src="assets/Images/landing/schedule.svg" alt="Schedule" data-cy="home-accordion-schedule-icon">
            </div>
            <div style="flex: 1; position: relative; top: 3px; white-space: nowrap; min-width: 100px;" data-cy="home-accordion-schedule-label">
              Schedule ({{homeAccordionService.numScheduleItems}})
            </div>
            <div style="flex-basis: 130px; position: relative; top: 3px; display: flex; text-align: center;" (mouseenter)="isDateHovered = true" (mouseleave)="isDateHovered = false" data-cy="home-accordion-schedule-date-control">
              <div [ngClass]="{'home-accordion-arrow-button': !isDateToday(), 'home-accordion-arrow-button-disabled': isDateToday()}" (click)="changeScheduleDate(false, $event, schedulePanelOpenState)" data-cy="home-accordion-schedule-prev-day">
                @if (isDateHovered) {
                  <lucide-icon name="chevron-left" [size]="20"></lucide-icon>
                }
              </div>
              <div style="flex-basis: fit-content; min-width: 120px;" data-cy="home-accordion-schedule-date">{{getDate()}}</div>
              <div class="home-accordion-arrow-button" (click)="changeScheduleDate(true, $event, schedulePanelOpenState)" data-cy="home-accordion-schedule-next-day">
                @if (isDateHovered) {
                  <lucide-icon name="chevron-right" [size]="20"></lucide-icon>
                }
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-home-schedule-view (accordionClose)="closeAccordion()" (requestClose)="homeAccordionCloseRequest();" (requestCheckOut)="schedDropdown.close();checkedOutState(); " data-cy="home-accordion-schedule-view"></app-home-schedule-view>
    </mat-expansion-panel>
    <!--TASKS-->
    @if (isExpanded) {
      <mat-expansion-panel data-cy="home-accordion-tasks-panel">
        <mat-expansion-panel-header data-cy="home-accordion-tasks-header">
          <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-tasks-title">
            <div class="accordion-header" data-cy="home-accordion-tasks-header-content">
              <div style="flex-basis: fit-content; margin-right: 20px; margin-top: 1px;" data-cy="home-accordion-tasks-icon-container">
                <img style="height: 50%;" src="assets/Images/landing/tasks.svg" alt="Tasks" data-cy="home-accordion-tasks-icon">
              </div>
              <div style="flex: 1; position: relative; top: 3px;" data-cy="home-accordion-tasks-label">
                My To Do List({{(TaskListService.tasks | async)?.length ?? 0}})
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-tdo-task-list [isExpanded]=false data-cy="home-accordion-task-list"></app-tdo-task-list>
      </mat-expansion-panel>
    }
    <!--  RECENT PATIENTS-->
    @if (isExpanded) {
      <mat-expansion-panel #recPatExp (opened)="_recentPatientPanelOpenState = true"
        (closed)="_recentPatientPanelOpenState = false" data-cy="home-accordion-recent-patients-panel">
        <mat-expansion-panel-header data-cy="home-accordion-recent-patients-header">
          <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-recent-patients-title">
            <div class="accordion-header" data-cy="home-accordion-recent-patients-header-content">
              <div style="flex-basis: fit-content; margin-right: 20px; margin-top: 1px;" data-cy="home-accordion-recent-patients-icon-container">
                <img  style="height: 50%;" src="assets/Images/landing/recent-patients.svg" alt="Recent Patients" data-cy="home-accordion-recent-patients-icon">
              </div>
              <div style="flex: 1; position: relative; top: 3px;" data-cy="home-accordion-recent-patients-label">
                Recent Patients
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-recent-patients data-cy="recent-patients-panel" [isOpen]="recentPatientPanelOpenState" [recentPatients]="patientService.recentPatients" (requestClose)="_recentPatientPanelOpenState = false; recPatExp.close();"></app-recent-patients>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
